const PENDING_REDIRECT_KEY = 'pending_login_redirect';
const EMAIL_PREFILL_KEY = 'login_email_prefill';
const PENDING_REDIRECT_TTL_MS = 24 * 60 * 60 * 1000;

interface PendingRedirect {
    redirect: string;
    storedAt: number;
}

export function storeExpiredLinkContext(redirectTo: string | null, email: string | null) {
    try {
        if (redirectTo) {
            const pending: PendingRedirect = {redirect: redirectTo, storedAt: Date.now()};
            localStorage.setItem(PENDING_REDIRECT_KEY, JSON.stringify(pending));
        } else {
            localStorage.removeItem(PENDING_REDIRECT_KEY);
        }
        if (email) {
            sessionStorage.setItem(EMAIL_PREFILL_KEY, email);
        } else {
            sessionStorage.removeItem(EMAIL_PREFILL_KEY);
        }
    } catch (error) {
        console.warn(error);
    }
}

export function consumePendingRedirect(): string | null {
    try {
        const value = localStorage.getItem(PENDING_REDIRECT_KEY);
        localStorage.removeItem(PENDING_REDIRECT_KEY);
        sessionStorage.removeItem(EMAIL_PREFILL_KEY);
        if (value === null) {
            return null;
        }
        const pending = JSON.parse(value) as Partial<PendingRedirect>;
        if (
            typeof pending.redirect === 'string' &&
            typeof pending.storedAt === 'number' &&
            Date.now() - pending.storedAt < PENDING_REDIRECT_TTL_MS
        ) {
            return pending.redirect;
        }
    } catch (error) {
        console.warn(error);
    }
    return null;
}

export function getEmailPrefill(): string {
    try {
        return sessionStorage.getItem(EMAIL_PREFILL_KEY) ?? '';
    } catch {
        return '';
    }
}
